import { useAppSelector } from "hooks/useApp"
import { closeModal } from "reducers/modal"
import ModalDelete from "components/ModalCustom/ModalDelete"
import ModalCheck from "components/ModalCustom/ModalCheck"

export const ModalController = () => {
  const modalType = useAppSelector((state) => state.modal.type)
  const props = useAppSelector((state) => state.modal.props)
  if (modalType === "Delete") {
    return <ModalDelete onCloseModal={closeModal} {...props.deleteModal} />
  }
  if (modalType === "Check" && props.checkModal) {
    return <ModalCheck {...props.checkModal} />
  }
  return null
}
